/**
 * @generated SignedSource<<e642f5e9e155c4c7a57efe47d3149c5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueCreateFooter_rankField$data = {
  readonly aliases?: ReadonlyArray<string> | null | undefined;
  readonly fieldId: string | null | undefined;
  readonly jqlTerm: string;
  readonly " $fragmentType": "IssueCreateFooter_rankField";
};
export type IssueCreateFooter_rankField$key = {
  readonly " $data"?: IssueCreateFooter_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueCreateFooter_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "IssueCreateFooter_rankField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "aliases"
        }
      ]
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "a4046922d80cd423f4205dcd4a424119";

export default node;
